/* eslint-disable @typescript-eslint/no-explicit-any */
export class DeferredPromise<T> {
  readonly promise: Promise<T>;
  readonly resolve: (value: T) => void;
  readonly reject: (reason?: any) => void;

  constructor() {
    let resolve: (value: T) => void;
    let reject: (reason?: any) => void;

    this.promise = new Promise<T>((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
    });

    this.resolve = resolve!;
    this.reject = reject!;
  }
}
